import type { RJSFConfiguration } from '@energywebfoundation/generic-green-proofs-ui';

export const rjsfConfiguration: RJSFConfiguration = {
  components: {},
  styles: {},
};
